import { HttpClient } from './serviceBase';
import { utils } from '../utils/utils'

const onError = (error) =>
    console.error({ handler: "CategoryService", error });

class CategoryService {
    SearchCategories = async (textFilter, pageSize, pageNumber) => {
        const queryString = utils.GetQueryStringsFromObject({ textFilter, pageSize, pageNumber });
        return await HttpClient.Get(`/api/categories/search?${queryString}`, {}, onError);
    }

    SeachDistressedCategories = async (textFilter, pageSize, pageNumber) => {
        const queryString = utils.GetQueryStringsFromObject({ textFilter, pageSize, pageNumber });
        return await HttpClient.Get(`/api/categories/distressed/search?${queryString}`, {}, onError);
    }
}

export default new CategoryService();